import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  API_URI = 'https://vigiliner.com.mx:1829/api';

  constructor(private http: HttpClient,public jwtHelper: JwtHelperService) { }
  /**
   * Se solicita revisar al usuario si ya a 
   * cambiado su contraeña por defecto.
  **/
  revisarResetPass(){
    return this.http.get<any>(`${this.API_URI}/revisarResetPass`);
  }
  /**
   * Se hace el cambio de la contraseña por defecto
   * @param contrasena es la nueva contraseña enviada por el usuario.
  **/
  restablecerPass(contrasena: string){
    return this.http.post<any>(`${this.API_URI}/restablecerPass`,{contrasena});
  }
  /**
   * Genera el token para poder restablecer la contraseña
   * @param correo Correo ingresado por el usuario se envia para revisión
   * @return Si es valido el correo o si ya tiene un token generado.
  **/
  generarToken(correo:string){
    return this.http.post<any>(`${this.API_URI}/generarToken`,{correo});
  }
  /**
   * Revisa que el token sea valido y exista
   * @param token se genera en generarToken
  **/
  revisarToken(token:string){
    return this.http.post<any>(`${this.API_URI}/revisarToken`,{token});
  }
  /**
   * Se realiza el cambio de contraseña
   * @param contrasena Nueva contraseña del usuario
   * @param uid Usuario al que se realiza el cambio
   * @param token Para validar correctamente
   * @param reseteopass cambiar estatus de forzar cambio de contraseña
  **/
  solicitudCambioPass(contrasena: string,uid:string=null,token:string=null,reseteopass:number=null){
    return this.http.post<any>(`${this.API_URI}/solicitudCambioPass`,{contrasena,uid,token,reseteopass});
  }
  /**
   * Nos trae todos los usuarios registrados por cliente
  **/
  listadoUsiarios(){
    return this.http.get<any>(`${this.API_URI}/listadoUsuarios`);
  }
  /**
   * Asignar las unidades puede ver el usuario
   * @param unidades arreglo con los ids de las unidades
   * @param usuario id del usuario al que se le asignan
  **/
  asignarunidades(unidades,usuario){
    return this.http.post<any>(`${this.API_URI}/asignarUnidades`,{unidades,usuario});
  }
}
